import { useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { SearchForm } from "@/components/SearchForm";
import { SearchStatsPanel } from "@/components/SearchStatsPanel";
import { ResultsTable } from "@/components/ResultsTable";

export default function SearchPage() {
  const [search, setSearch] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (payload) => {
    setLoading(true);
    setSearch(null);
    try {
      const res = await api.post("/searches", payload);
      setSearch(res.data);
      toast.success("Recherche terminee");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Erreur lors de la recherche");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-6 space-y-6" data-testid="search-page">
      <SearchForm onSubmit={handleSubmit} loading={loading} />
      {search && (
        <>
          <SearchStatsPanel search={search} />
          <ResultsTable searchId={search.id} />
        </>
      )}
    </div>
  );
}
